import * as React from 'react';

function SvgActEdit(props) {
    return (
        <svg
            viewBox="0 0 128 128"
            {...props}
        >
            <path
                d="M99.92 53.76l4.1-4.1a8.76 8.76 0 000-12.37L90.71 24a8.76 8.76 0 00-12.37 0l-4.1 4.1zM27.87 74.45l42.84-42.84 25.68 25.68-42.84 42.84zm-2.7 4.36l-3.61 18.67a7.65 7.65 0 007.51 9.1 7.91 7.91 0 001.45-.14l18.67-3.61z"
                fill="currentColor"
            />
        </svg>
    );
}

export default SvgActEdit;
